const WEAVE_BILL_PAY_DOMAIN = 'weavebillpay.com';

export const buildProductionInvoiceUrl = (invoiceResponseUrl: string | undefined, siteName: string | null) => {
  if (!invoiceResponseUrl || !siteName) {
    return invoiceResponseUrl;
  }

  let url: URL;
  try {
    url = new URL(invoiceResponseUrl);
  } catch {
    return invoiceResponseUrl;
  }

  if (siteName) {
    url.hostname = `${siteName}.${WEAVE_BILL_PAY_DOMAIN}`;
  }

  return url.toString();
};
